<template>
    <div class="container">
        <div class="header">
            <div class="header-left">
                <el-dropdown style="margin-left: 0px;" v-if="manager || category">
                    <el-button type="primary" @click.native="handleClick('insert')">
                        入库<i class="el-icon-arrow-down el-icon--right"></i>
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item @click.native="handleClick('insert')">入库</el-dropdown-item>
                        <el-dropdown-item @click.native="updateStatusOpen(null, 1, false)">重入库</el-dropdown-item>
                        <el-dropdown-item @click.native="loadData(1)">刷新</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>

                <el-dropdown style="margin-left: 10px;">
                    <el-button type="primary">
                        更多操作<i class="el-icon-arrow-down el-icon--right"></i>
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item @click.native="updateStatusOpen(null, 2, true)">图片代卖</el-dropdown-item>
                        <el-dropdown-item @click.native="updateStatusOpen(null, 3, true)">实物代卖</el-dropdown-item>
                        <el-dropdown-item @click.native="updateStatusOpen(null, 5, true)">钱币锁定</el-dropdown-item>
                        <el-dropdown-item @click.native="updateStatusOpen(null, 6, true)"
                            v-if="manager || category">钱币出库</el-dropdown-item>
                        <el-dropdown-item @click.native="downloadOpen()" v-if="manager">创建下载任务</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
            <div class="header-right">
                <el-select v-model="filterParams.customer_id" placeholder="请选择出品人" @change="loadData(1)"
                    style="width: 120px;" v-if="manager || distribute" class="header-input">
                    <el-option :label="'不限出品人'" :value="''"></el-option>
                    <el-option v-for="item in customers" :key="item.customerId" :label="item.customerName"
                        :value="item.customerId"></el-option>
                </el-select>
                <el-select v-model="filterParams.product_public" placeholder="请选择公开状态" @change="loadData(1)"
                    style="width: 105px;" v-if="manager" class="header-input">
                    <el-option :label="'不限公开'" :value="''"></el-option>
                    <el-option v-for="item in publics" :key="item.value" :label="item.label"
                        :value="item.value"></el-option>
                </el-select>
                <!-- <el-select v-model="filterParams.product_vip" placeholder="请选择VIP状态" @change="loadData(1)"
                    style="width: 100px;" v-if="manager" class="header-input">
                    <el-option :label="'不限VIP'" :value="''"></el-option>
                    <el-option v-for="item in vips" :key="item.value" :label="item.label"
                        :value="item.value"></el-option>
                </el-select> -->
                <el-select v-model="filterParams.product_pay" placeholder="请选择结算状态" @change="loadData(1)"
                    style="width: 105px;" v-if="manager || category" class="header-input">
                    <el-option :label="'不限结算'" :value="''"></el-option>
                    <el-option v-for="item in payArray" :key="item.value" :label="item.label"
                        :value="item.value"></el-option>
                </el-select>
                <el-select v-model="filterParams.product_status" placeholder="请选择钱币状态" @change="loadData(1)"
                    style="width: 110px;" class="header-input">
                    <el-option :label="'不限状态'" :value="''"></el-option>
                    <el-option v-for="item in productStatusArray" :key="item.value" :label="item.label"
                        :value="item.value"></el-option>
                </el-select>
                <el-select v-model="filterParams.address_id" placeholder="请选择库存地" @change="loadData(1)"
                    style="width: 120px;" class="header-input" v-if="!category">
                    <el-option :label="'不限库存地'" :value="''"></el-option>
                    <el-option v-for="item in addresses" :key="item.addressId" :label="item.addressName"
                        :value="item.addressId"></el-option>
                </el-select>
                <el-select v-model="filterParams.grade_id" placeholder="请选择评级公司" @change="loadData(1)"
                    style="width: 130px;" class="header-input">
                    <el-option :label="'不限评级公司'" :value="''"></el-option>
                    <el-option v-for="item in grades" :key="item.gradeId" :label="item.gradeName"
                        :value="item.gradeId"></el-option>
                </el-select>
                <el-select v-model="filterParams.category_id" placeholder="请选择钱币朝代" @change="loadData(1)"
                    style="width: 105px;" class="header-input" v-if="!category || all">
                    <el-option :label="'不限朝代'" :value="''"></el-option>
                    <el-option :label="group.categoryName" :value="group.categoryId"
                        v-for="group in categorys"></el-option>
                </el-select>
                <!-- <el-input v-model="filterParams.out_name" placeholder="出库代卖人" class="header-input"
                    style="width: 110px;" @change="loadData(1)"></el-input> -->
                <el-select v-model="filterParams.admin_ids" placeholder="请选择代卖人" @change="loadData(1)"
                    style="width: 120px;" class="header-input" v-if="!category">
                    <el-option :label="'不限代卖人'" :value="''"></el-option>
                    <el-option :label="item.adminName" :value="item.adminId" v-for="item in admins"></el-option>
                </el-select>
                <el-input v-model="filterParams.product_name" placeholder="钱币名称" class="header-input"
                    style="width: 110px;" @change="loadData(1)"></el-input>
                <el-input v-model="filterParams.product_appraisal" placeholder="评级编码" class="header-input"
                    style="width: 110px;" @change="loadData(1)"></el-input>
                <el-input v-model="filterParams.product_prize_start" placeholder="价格下限" class="header-input"
                    style="width: 90px;" @change="loadData(1)"></el-input>
                <el-input v-model="filterParams.product_prize_end" placeholder="价格上限" class="header-input"
                    style="width: 90px;" @change="loadData(1)"></el-input>
                <el-button type="primary" @click="loadData(1)">搜索</el-button>
            </div>
        </div>
        <el-table :data="records" border style="min-width: 1660px;" @sort-change="sortChange" :default-sort="sortParams"
            @selection-change="selectRowsChange">
            <el-table-column type="selection" width="40"></el-table-column>
            <el-table-column label="钱币名称" sortable prop="productName" width="280">
                <template slot-scope="scope">
                    <el-popover placement="top-start" trigger="hover">
                        <el-image style="width: 300px; height: 300px;" :src="getFirstImageSrc(scope.row.productImages)"
                            fit="cover"></el-image>
                        <el-button type="text" slot="reference">{{ scope.row.productName }}</el-button>
                    </el-popover>
                </template>
            </el-table-column>
            <el-table-column prop="categoryId" label="朝代" sortable width="140">
                <template slot-scope="scope">
                    <el-select v-if="manager" v-model="scope.row.categoryId" placeholder="请选择朝代"
                        @change="updateCategory(scope.row.productId, $event)">
                        <el-option v-for="item in categorys" :key="item.categoryId" :label="item.categoryName"
                            :value="item.categoryId"></el-option>
                    </el-select>
                    <span v-else>{{ scope.row.categoryName }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="gradeName" label="评级公司" sortable></el-table-column>
            <el-table-column prop="productAppraisal" label="评级编码" sortable></el-table-column>
            <el-table-column prop="productPrize" label="钱币价格" sortable width="110">
                <template slot-scope="scope">
                    <!-- <el-select v-model="scope.row.categoryId" placeholder="请选择朝代"
                        @change="updateCategory(scope.row.productId, $event)">
                        <el-option v-for="item in categorys" :key="item.categoryId" :label="item.categoryName"
                            :value="item.categoryId"></el-option>
                    </el-select> -->
                    <el-input v-if="manager" v-model="scope.row.productPrize"
                        @change="updatePrize(scope.row.productId, $event)"></el-input>
                    <span v-else>{{ scope.row.productPrize }}</span>
                </template>
            </el-table-column>
            <!-- <el-table-column prop="customerName" label="出品人" v-if="!application" sortable width="90"></el-table-column>
            <el-table-column prop="addressName" label="库存地" sortable width="120"></el-table-column> -->
            <el-table-column prop="customerName" label="出品人" v-if="!application" sortable width="120">
                <template slot-scope="scope">
                    <el-select v-if="manager" v-model="scope.row.customerId" placeholder="请选择出品人"
                        @change="updateCustomer(scope.row.productId, $event)">
                        <el-option v-for="item in customers" :key="item.customerId" :label="item.customerName"
                            :value="item.customerId"></el-option>
                    </el-select>
                    <span v-else>{{ scope.row.customerName }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="addressName" label="库存地" sortable width="120">
                <template slot-scope="scope">
                    <el-select v-if="manager" v-model="scope.row.addressId" placeholder="请选择库存地"
                        @change="updateAddress(scope.row.productId, $event)">
                        <el-option v-for="item in addresses" :key="item.addressId" :label="item.addressName"
                            :value="item.addressId"></el-option>
                    </el-select>
                    <span v-else>{{ scope.row.addressName }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="productStatus" label="钱币状态" sortable width="150">
                <template slot-scope="scope">
                    <el-popover placement="top-start" trigger="hover" @show="popoverShow(scope.row.productId)"
                        v-if="scope.row.productStatus == 2 || scope.row.productStatus == 3 || scope.row.productStatus == 4">
                        <div>
                            <div v-for="item in popovers">{{ item.adminName }}：{{ getProductStatusName(item.resaleType)
                                }}</div>
                        </div>
                        <el-button type="text" slot="reference">{{ getProductStatusName(scope.row.productStatus)
                            }}</el-button>
                    </el-popover>
                    <span v-else>{{ getProductStatusName(scope.row.productStatus) }}</span>
                    <div v-if="adminSuper && scope.row.productStatus == 5" style="color: #FF0000; font-weight: bold;">{{
                    scope.row.lockName }}</div>
                    <div v-if="adminSuper && scope.row.productStatus == 6">
                        <span v-if="scope.row.productPay == 1">{{ scope.row.outName }}：{{
                    getPayName(scope.row.productPay) }}</span>
                        <span v-else style="color: #FF0000; font-weight: bold;">{{ scope.row.outName }}：{{
                    getPayName(scope.row.productPay) }}</span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="productPublic" label="公开" sortable width="80" v-if="manager">
                <template slot-scope="scope">{{ scope.row.productPublic == 1 ? "公开" : "不公开" }}</template>
            </el-table-column>
            <!-- <el-table-column prop="productPublic" label="VIP" sortable width="70">
                <template slot-scope="scope">{{ scope.row.productVip == 1 ? "VIP" : "-" }}</template>
            </el-table-column> -->
            <el-table-column prop="lastUpdateDate" label="最新操作时间" sortable width="170">
                <template slot-scope="scope">
                    {{ convertToDate(scope.row.productDateLast) }}
                </template>
            </el-table-column>
            <el-table-column prop="productImages" label="钱币底图" width="85">
                <template slot-scope="scope">
                    <div style="position: relative; width: 50px; height: 50px;">
                        <el-image style="width: 50px; height: 50px;" :src="getFirstImageSrc(scope.row.productImages)"
                            fit="cover" :preview-src-list="getImageSrcList(scope.row.productImages)"></el-image>
                        <div v-if="scope.row.productImages.split(',').length > 1"
                            style="position: absolute; background-color: #FF0000; top: 0px; right: 0px; z-index: 99; width: 16px; height: 16px; line-height: 16px; text-align: center; color: #FFFFFF; font-size: 10px; border-radius: 50%;">
                            {{ scope.row.productImages.split(",").length }}</div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="120">
                <template slot-scope="scope">
                    <!-- <el-button @click="handleClick('update', scope.row)" type="text" size="small">锁定</el-button>
                    <el-popconfirm title="确认出库吗？将删除所有的代卖信息" @confirm="productOut(scope.row.productId)"
                        v-if="scope.row.productStatus < 4">
                        <el-button type="text" size="small" slot="reference" style="margin-right: 10px;">出库</el-button>
                    </el-popconfirm>
                    <br />
                    <el-button @click="updateStatusOpen(scope.row.productId, 3)" type="text"
                        v-if="scope.row.productStatus < 4" size="small">实物代卖</el-button>
                    <el-button @click="updateStatusOpen(scope.row.productId, 2)" type="text"
                        v-if="scope.row.productStatus < 4" size="small">图片代卖</el-button>
                    <el-button @click="handleClick('update', scope.row)" type="text" size="small">编辑</el-button>
                    <el-button @click="handleClick('delete', scope.row)" type="text" size="small">删除</el-button> -->
                    <el-dropdown>
                        <el-button type="primary" size="small">
                            更多操作<i class="el-icon-arrow-down el-icon--right"></i>
                        </el-button>
                        <el-dropdown-menu slot="dropdown">
                            <!-- <el-dropdown-item
                                @click.native="downloadAllImages(getImageSrcList(scope.row.productImages), scope.row.productAppraisal)">批量下载</el-dropdown-item> -->
                            <el-dropdown-item v-if="scope.row.productVideo"
                                @click.native="videoOpen(scope.row.productVideo)">视频播放</el-dropdown-item>
                            <el-dropdown-item @click.native="updateStatusOpen(scope.row.productId, 2, false)"
                                v-if="scope.row.productStatus < 5 && (((manager || category) && scope.row.productVip == 1) || scope.row.productVip == 0)">图片代卖</el-dropdown-item>
                            <el-dropdown-item @click.native="updateStatusOpen(scope.row.productId, 3, false)"
                                v-if="scope.row.productStatus < 5 && (((manager || category) && scope.row.productVip == 1) || scope.row.productVip == 0)">实物代卖</el-dropdown-item>
                            <el-dropdown-item @click.native="updateStatusOpen(scope.row.productId, 5, false)"
                                v-if="scope.row.productStatus < 5 && (((manager || category) && scope.row.productVip == 1) || scope.row.productVip == 0)">钱币锁定</el-dropdown-item>
                            <el-dropdown-item @click.native="updateStatusOpen(scope.row.productId, 6, false)"
                                v-if="scope.row.productStatus != 6 && (manager || category)">钱币出库</el-dropdown-item>
                            <el-dropdown-item @click.native="updateStatusOpen(scope.row.productId, 11, false)"
                                v-if="scope.row.productStatus == 6 && (manager || category)">撤销出库</el-dropdown-item>
                            <el-dropdown-item @click.native="updateStatusOpen(scope.row.productId, 7, false)"
                                v-if="scope.row.productStatus == 5 && (manager || category)">钱币退回</el-dropdown-item>
                            <el-dropdown-item @click.native="logOpen(scope.row.productId)">操作详情</el-dropdown-item>
                            <el-dropdown-item @click.native="handleClick('update', scope.row)"
                                v-if="manager || category">钱币编辑</el-dropdown-item>
                            <!-- <el-dropdown-item @click.native="handleClick('delete', scope.row)"
                                v-if="manager">钱币删除</el-dropdown-item> -->
                        </el-dropdown-menu>
                    </el-dropdown>
                </template>
            </el-table-column>
        </el-table>
        <div v-if="total > 0" class="page-wrapper">
            <el-pagination @size-change="sizeChange" @current-change="currentChange" :current-page="current"
                :page-sizes="[10, 20, 30, 40, 100, 500]" :page-size="size" layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </div>
        <el-dialog :title="getModalTitle()" :visible.sync="isHandle" width="30%" :close-on-click-modal="false">
            <div v-if="handle == 'insert' || handle == 'update'">
                <el-form ref="form" :model="handleInfo" label-width="90px">
                    <el-form-item label="钱币朝代" v-if="manager">
                        <el-select v-model="handleInfo.categoryId" placeholder="请选择钱币朝代" style="width: 100%;">
                            <el-option v-for="group in categorys" :key="group.categoryId" :label="group.categoryName"
                                :value="group.categoryId"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="出品人" v-if="manager">
                        <el-select v-model="handleInfo.customerId" placeholder="请选择" style="width: 100%;"
                            @change="customerChange">
                            <el-option :label="'暂无'" :value="''"></el-option>
                            <el-option v-for="item in customers" :key="item.customerId" :label="item.customerName"
                                :value="item.customerId"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="是否公开" v-if="manager">
                        <el-select v-model="handleInfo.productPublic" placeholder="请选择" style="width: 100%;"
                            @change="publicChange">
                            <el-option v-for="item in publics" :key="item.value" :label="item.label"
                                :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <!-- <el-form-item label="是否VIP">
                        <el-select v-model="handleInfo.productVip" placeholder="请选择" style="width: 100%;"
                            @change="vipChange">
                            <el-option v-for="item in vips" :key="item.value" :label="item.label"
                                :value="item.value"></el-option>
                        </el-select>
                    </el-form-item> -->
                    <el-form-item label="是否结算" v-if="handleInfo.productStatus == 6">
                        <el-select v-model="handleInfo.productPay" placeholder="请选择" style="width: 100%;"
                            @change="payChange">
                            <el-option v-for="item in payArray" :key="item.value" :label="item.label"
                                :value="item.value" v-if="item.value < 2"></el-option>
                        </el-select>
                    </el-form-item>
                    <!-- <el-form-item label="库存状态">
                        <el-select v-model="handleInfo.productStatus" placeholder="请选择" style="width: 100%;">
                            <el-option v-for="item in productStatusArray" :key="item.value" :label="item.label"
                                :value="item.value"></el-option>
                        </el-select>
                    </el-form-item> -->
                    <el-form-item label="评级公司">
                        <el-select v-model="handleInfo.gradeId" placeholder="请选择" style="width: 100%;"
                            @change="gradeChange">
                            <el-option :label="'暂无'" :value="''"></el-option>
                            <el-option v-for="item in grades" :key="item.gradeId" :label="item.gradeName"
                                :value="item.gradeId"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="库存地">
                        <el-select v-model="handleInfo.addressId" placeholder="请选择" style="width: 100%;"
                            @change="addressChange">
                            <el-option :label="'暂无'" :value="''"></el-option>
                            <el-option v-for="item in addresses" :key="item.addressId" :label="item.addressName"
                                :value="item.addressId"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="钱币名称">
                        <el-input v-model="handleInfo.productName"></el-input>
                    </el-form-item>
                    <el-form-item label="钱币价格">
                        <el-input v-model="handleInfo.productPrize"></el-input>
                    </el-form-item>
                    <!-- <el-form-item label="钱币简述">
                        <el-input v-model="handleInfo.productDesc"></el-input>
                    </el-form-item> -->
                    <el-form-item label="评级编码">
                        <el-input v-model="handleInfo.productAppraisal"></el-input>
                    </el-form-item>
                    <el-form-item label="钱币图片">
                        <div class="upload-wrapper">
                            <div class="upload-item" v-for="(img, index) in getFiles('productImages')">
                                <!-- <el-image class="upload-image" :src="getImageSrc(img)" fit="cover" -->
                                <el-image class="upload-image" :src="getThumbImageSrc(img)" fit="cover"
                                    :preview-src-list="getImageArrayByArrIndex(getFiles('productImages'), index)"></el-image>
                                <div class="upload-toolbar">
                                    <div @click="uploadRemove('productImages', index)" class="upload-tool">删除</div>
                                    <div @click="uploadFirst('productImages', index)" class="upload-tool"
                                        v-if="index > 0">封面
                                    </div>
                                </div>
                            </div>
                            <div class="upload-item"
                                style="border: 1px dashed #CCCCCC; text-align: center; line-height: 100px;"
                                v-if="uploadLoading && uploadColumn == 'productImages'">
                                上传中...
                            </div>
                            <el-upload :data="{ column: 'productImages' }" accept=".jpg,.jpeg,.bmp,.png"
                                :multiple="true" :headers="uploadHeaders" :action="uploadUrl" :show-file-list="false"
                                :on-success="uploadSuccessMulti" :before-upload="uploadBefore"
                                @click.native="uploadClick('productImages')">
                                <i class="el-icon-plus upload-icon"></i>
                            </el-upload>
                        </div>
                    </el-form-item>
                    <el-form-item label="钱币视频">
                        <div class="upload-wrapper">
                            <div class="upload-item" v-if="handleInfo.productVideo">
                                <video style="width: 100px; height: 100px; background-color: #000000;" controls
                                    :src="getImageSrc(handleInfo.productVideo)"></video>
                            </div>
                            <div class="upload-item"
                                style="border: 1px dashed #CCCCCC; text-align: center; line-height: 100px;"
                                v-if="uploadLoading && uploadColumn == 'productVideo'">
                                上传中...
                            </div>
                            <div class="upload-item" @click="handleInfo.productVideo = ''"
                                style="border: 1px dashed #CCCCCC; text-align: center; line-height: 100px; cursor: pointer;"
                                v-if="!uploadLoading && handleInfo.productVideo">
                                删除视频
                            </div>
                            <el-upload :data="{ column: 'productVideo' }" accept=".mp4" :multiple="false"
                                :headers="uploadHeaders" :action="uploadUrl" :show-file-list="false"
                                :on-success="uploadVideoSuccess" :before-upload="uploadBefore"
                                @click.native="uploadClick('productVideo')">
                                <i class="el-icon-plus upload-icon"></i>
                            </el-upload>
                        </div>
                    </el-form-item>
                </el-form>
            </div>
            <div v-if="handle == 'delete'">您确认要删除吗？删除后将不可恢复！</div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="isHandle = false">取 消</el-button>
                <el-button type="primary" @click="handleSubmit()">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog :title="getLogTypeName(scheduleForm.logType)" :visible.sync="statusLayer" width="30%"
            :close-on-click-modal="false">
            <el-form ref="form" label-width="90px">
                <el-form-item label="代卖人" v-if="(manager || category || distribute) && scheduleForm.logType > 1">
                    <el-select v-model="scheduleForm.salerId" placeholder="请选择代卖人" style="width: 100%;"
                        @change="salerChange">
                        <el-option v-for="item in saleAdmins" :key="item.adminId" :label="item.adminName"
                            :value="item.adminId"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="评级编码" v-if="(manager || distribute) && scheduleForm.logType == 1">
                    <el-input v-model="scheduleForm.productCode"></el-input>
                </el-form-item>
                <el-form-item label="是否结算" v-if="(manager || distribute || category) && scheduleForm.logType == 6">
                    <el-select v-model="scheduleForm.productPay" placeholder="请选择结算状态" style="width: 100%;">
                        <el-option v-for="item in payArray" :key="item.value" :label="item.label"
                            :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="操作备注">
                    <el-input v-model="scheduleForm.memo"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="updateStatusClose()">取 消</el-button>
                <el-button type="primary" @click="updateStatusConfirm()">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog title="操作日志" :visible.sync="logLayer" width="30%" :close-on-click-modal="false">
            <div class="block">
                <el-timeline>
                    <el-timeline-item v-for="(log, index) in logs" :key="index" type="primary" color="#0bbd87"
                        v-if="log.logType <= 4 || adminSuper" size="large" :timestamp="convertToDate(log.logDate)">
                        {{ getLogTypeName(log.logType) }}
                        <span v-if="log.salerId"> / 代卖人：{{ log.salerName }}</span>
                        <span v-if="log.adminId"> / 操作人：{{ log.adminName }}</span>
                        <span v-if="log.logMemo && (log.logType != 6 || (manager || category))"
                            style="color: #FF0000; font-weight: bold;"> / 备注：{{ log.logMemo }}</span>
                    </el-timeline-item>
                </el-timeline>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="logLayer = false">关 闭</el-button>
            </span>
        </el-dialog>
        <!-- 视频播放 -->
        <el-dialog title="视频播放" :visible.sync="videoLayer" width="50%" :close-on-click-modal="false">
            <div class="block">
                <video controls :src="getImageSrc(videoSrc)"
                    style="max-width: 50vw; max-height: 50vh; display: block; margin: 0px auto;"></video>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="videoLayer = false">关 闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import verifyMixin from "@/mixins/verify-mixin.js"
import listMixin from "@/mixins/list-mixin.js"
import uploadMixin from "@/mixins/upload-mixin.js"
import imageMixin from "@/mixins/image-mixin.js"
import enumMixin from "@/mixins/enum-mixin.js"
import scheduleMixin from "@/mixins/schedule-mixin.js"
import axios from "axios"

import { API, doGet, doPatch, doPost } from "@/api/api.js"

export default {
    mixins: [verifyMixin, listMixin, uploadMixin, imageMixin, enumMixin, scheduleMixin],
    props: {
        adminSuper: {
            type: Boolean,
            default: false
        },
        manager: {
            type: Boolean,
            default: false
        },
        distribute: {
            type: Boolean,
            default: false
        },
        application: {
            type: Boolean,
            default: false
        },
        category: {
            type: Boolean,
            default: false
        },
        all: {
            type: Boolean,
            default: false
        },
    },
    data: function () {
        return {
            downloadForm: {
                downloadName: "",
                downloadProductIds: ""
            },
            videoLayer: false,
            videoSrc: "",
            lastGradeId: "",
            popovers: [],
            logLayer: false,
            customers: [],
            grades: [],
            admins: [],
            addresses: [],
            categorys: [],
            logs: [],
            saleAdmins: [],
            adminInfo: {},
            publics: [
                {
                    label: "公开",
                    value: 1
                },
                {
                    label: "不公开",
                    value: 0
                },
            ],
            vips: [
                {
                    label: "非VIP",
                    value: 0
                },
                {
                    label: "VIP",
                    value: 1
                }
            ],
        }
    },
    methods: {
        validateSubmit: function() {
            if (!this.handleInfo.categoryId) {
                this.$message.warning("朝代信息不可为空");
                return false;
            }
            return true;
        },
        downloadOpen: function () {
            if (this.selectRows == null || this.selectRows.length == 0) {
                this.$message.warning("未选中数据");
                return;
            }
            let ids = "";
            for (let i = 0; i < this.selectRows.length; i++) {
                if (i > 0) {
                    ids += ",";
                }
                ids += this.selectRows[i].productId;
            }
            this.downloadForm.downloadProductIds = ids;
            this.$prompt('任务名称', '创建下载任务', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputPattern: /\S/,
                inputErrorMessage: '任务名称不能为空'
            }).then(async ({ value }) => {
                this.downloadForm.downloadName = value;
                let resultObj = await doPost(API.REST.DOWNLOAD, this.downloadForm);
                if (resultObj.errorCode == 0) {
                    this.$message.success("创建下载任务成功");
                }
                else {
                    this.$message.warning("创建下载任务失败");
                }
            }).catch(() => { })
        },
        videoOpen: function (videoSrc) {
            this.videoLayer = true;
            this.videoSrc = videoSrc;
        },
        uploadVideoSuccess: function (res) {
            this.handleInfo.productVideo = res.fileName;
            this.uploadLoading = false;
            this.$forceUpdate();
        },
        customerChange: function (e) {
            localStorage.setItem("CURRENT_CUSTOMER_ID", e);
            this.handleInfo.customerId = e;
            this.$forceUpdate();
        },
        vipChange: function (e) {
            this.handleInfo.productVip = e;
            this.$forceUpdate();
        },
        payChange: function (e) {
            this.handleInfo.productPay = e;
            this.$forceUpdate();
        },
        publicChange: function (e) {
            this.handleInfo.productPublic = e;
            this.$forceUpdate();
        },
        gradeChange: function (e) {
            this.lastGradeId = e;
            this.handleInfo.gradeId = e;
            this.$forceUpdate();
        },
        addressChange: function (e) {
            this.handleInfo.addressId = e;
            localStorage.setItem("CURRENT_ADDRESS_ID", e);
            this.$forceUpdate();
        },
        logOpen: async function (productId) {
            this.logs = await doGet(API.ALL.LOG, { productId: productId });
            this.logLayer = true;
        },
        popoverShow: async function (productId) {
            this.popovers = [];
            let res = await doGet(API.ALL.RESALE, { product_id: productId });
            this.popovers = res.records;
        },
        reloadData: async function () {
            this.customers = await doGet(API.ALL.CUSTOMER);
            this.grades = await doGet(API.ALL.GRADE);
            this.admins = await doGet(API.ALL.ADMIN);
            this.categorys = await doGet(API.ALL.CATEGORY);
            this.addresses = await doGet(API.ALL.ADDRESS);
            this.adminInfo = await doGet(API.ADMIN_INFO);
            this.$forceUpdate();
        },
        afterUpload: function (res) {
            if (res != null && res.data != null) {
                // if (res.data.coinName && !this.handleInfo.productName) {
                if (res.data.coinName) {
                    let styleName = "";
                    console.log(res.data.attr);
                    if (res.data.attr && res.data.attr.length) {
                        for (let i = 0; i < res.data.attr.length; i++) {
                            if (res.data.attr[i].indexOf("版式") >= 0) {
                                styleName = res.data.attr[i].split('：')[1];
                                break;
                            }
                        }
                    }
                    // this.handleInfo.productName = "公博" + res.data.goodsScore + res.data.coinName.replace(/\s+/g, '') + styleName.replace(/\s+/g, '');
                    this.$set(this.handleInfo, 'productName', "公博" + res.data.goodsScore + res.data.coinName.replace(/\s+/g, '') + styleName.replace(/\s+/g, ''))
                }
                if (res.data.ratingCode && !this.handleInfo.productAppraisal) {
                    // this.handleInfo.productAppraisal = res.data.ratingCode;
                    this.$set(this.handleInfo, 'productAppraisal', res.data.ratingCode)
                }
                if (res.data.companyShortName && !this.handleInfo.gradeId) {
                    for (let i = 0; i < this.grades.length; i++) {
                        if (this.grades[i].gradeName == res.data.companyShortName) {
                            this.handleInfo.gradeId = this.grades[i].gradeId;
                            this.lastGradeId = this.grades[i].gradeId;
                            break;
                        }
                    }
                }
            }
        },
        beforeHandleOpen: function (handle) {
            if (handle == "insert") {
                if (this.lastGradeId) {
                    this.handleInfo.gradeId = this.lastGradeId;
                }
                else {
                    this.handleInfo.gradeId = this.grades[0].gradeId;
                }
                this.handleInfo.productStatus = this.productStatusArray[0].value;
                this.handleInfo.productPublic = this.publics[0].value;
                if (this.manager) { //通用钱币管理
                    this.handleInfo.customerId = this.customers[0].customerId;
                    if (localStorage.getItem("CURRENT_CUSTOMER_ID")) {
                        this.handleInfo.customerId = localStorage.getItem("CURRENT_CUSTOMER_ID");
                    }
                    if (localStorage.getItem("CURRENT_ADDRESS_ID")) {
                        this.handleInfo.addressId = localStorage.getItem("CURRENT_ADDRESS_ID");
                    }
                    else {
                        this.handleInfo.addressId = this.addresses[0].addressId;
                    }
                }
                else {  //专属钱币管理
                    this.handleInfo.customerId = this.adminInfo.customerId;
                    this.handleInfo.addressId = this.adminInfo.addressId;
                    this.handleInfo.categoryId = this.adminInfo.categoryId;
                }
            }
        },
        updateCategory: async function (productId, categoryId) {
            let resultObj = await doPatch(API.REST.PRODUCT, {
                product_id: productId,
                category_id: categoryId
            });
            this.showResult(resultObj);
        },
        updateCustomer: async function (productId, customerId) {
            console.log("productId=" + productId);
            let resultObj = await doPatch(API.REST.PRODUCT, {
                product_id: productId,
                customer_id: customerId
            });
            this.showResult(resultObj);
        },
        updateAddress: async function (productId, addressId) {
            let resultObj = await doPatch(API.REST.PRODUCT, {
                product_id: productId,
                address_id: addressId
            });
            this.showResult(resultObj);
        },
        updatePrize: async function (productId, productPrize) {
            let resultObj = await doPatch(API.REST.PRODUCT, {
                product_id: productId,
                product_prize: productPrize,
                product_date_prize: Math.floor(new Date().getTime() / 1000)
            });
            this.showResult(resultObj);
        },
        downloadSingleImage: function (url, name) {
            axios({
                url,
                method: "GET",
                responseType: 'blob'
            }).then(res => {
                const blob = new Blob([res.data]);
                const url = URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = name;
                a.click();
                URL.revokeObjectURL(url);
            });
        },
        downloadAllImages: function (urls, code) {
            this.$message.warning(code + "正在批量下载，请稍后...");
            for (let i = 0; i < urls.length; i++) {
                if (!code) {
                    code = (new Date()).getTime();
                }
                this.downloadSingleImage(urls[i], code + "-" + (i + 1) + ".jpg");
            }
        }
    },
    created: function () {
        this.tag = "PRODUCT";
        this.uploads.push({
            column: "productImages",
            files: []
        });
        this.filterParams = {
            product_public: (this.manager ? "" : "1"),
            product_vip: "",
            product_pay: "",
            address_id: "",
            customer_id: "",
            product_status: "",
            grade_id: "",
            category_id: "",
            product_appraisal: "",
            product_prize_start: "",
            product_prize_end: "",
            product_name: "",
            category_mode: -1,
            admin_ids: "",
        };
        if (this.manager) { //钱币管理处，默认不显示（专有朝代），其他类型，则全部显示
            this.filterParams.category_mode = 0;
        }
        if (this.category) {  //专有钱币管理
            if (this.all) {
                this.filterParams.category_mode = 2;    //显示所有专属专有钱币
            }
            else {
                this.filterParams.category_mode = 1;    //只显示当前管理员专属钱币
            }
        }
        this.sortParams.prop = "productDateLast";
        this.sortParams.order = "DESC";
    }
}
</script>
<style scoped lang="less">
@import "@/assets/style/list-style.less";
@import "@/assets/style/upload-style.less";


// /deep/ .el-table__header-wrapper .el-checkbox__input::after {
//     content: '全选';
//     position: absolute;
//     margin-left: 5px;
//     font-size: 14px;
//     color: #909399;
//     font-weight: bold;
// }

.el-table {
    /* 关闭浏览器滚动优化，强制渲染所有内容 */
    will-change: transform;
    /* 强制GPU加速，解决渲染卡顿和消失问题 */
    transform: translateZ(0);
}

/* 修复固定列与滚动列不同步 */
.el-table__body-wrapper {
    overflow-x: auto;
    /* 解决滚动时内容闪烁 */
    -webkit-overflow-scrolling: touch;
}

/* 修复表头与内容不对齐 */
.el-table__header-wrapper {
    overflow-x: hidden;
}
</style>